module.exports = __webpack_public_path__ + "img/close-filled.b48ab056.svg";